import { useContentWidth } from './useContentWidth.js';
export function useAvailableWidth(element) {
    return useContentWidth(element?.parentElement ?? undefined);
}
